import React from 'react';
import { Link } from 'react-router-dom';
import {
  AMAZON_URL,
  BOOK_COVER,
  BOOK_TITLE,
  IG_URL,
  TIKTOK_URL,
  LINKEDIN_URL,
} from '../lib/bookLinks';
import './LinksPage.css';

export const LinksPage: React.FC = () => {
  return (
    <div className="links-wrapper">
      <main className="links-main">
        <div className="links-eyebrow">
          <span>Bobby Malik</span>
          <span className="links-eyebrow-dot" aria-hidden="true"></span>
          <span>Wealth Financial Systems</span>
        </div>

        <p className="links-tagline">
          Options research and the boring wealth system that funds it.
        </p>

        <nav className="links-list" aria-label="Destinations">
          <Link to="/book" className="links-link links-link--primary">
            <span className="links-icon links-icon--cover" aria-hidden="true">
              <img src={BOOK_COVER} alt="" />
            </span>
            <span className="links-text">
              <span className="links-title">{BOOK_TITLE}</span>
              <span className="links-sub">The book · about it + buy on Amazon</span>
            </span>
            <span className="links-arrow" aria-hidden="true">→</span>
          </Link>

          <Link to="/dashboard" className="links-link">
            <span className="links-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 3h7v9H3z" />
                <path d="M14 3h7v5h-7z" />
                <path d="M14 12h7v9h-7z" />
                <path d="M3 16h7v5H3z" />
              </svg>
            </span>
            <span className="links-text">
              <span className="links-title">The Book Tools</span>
              <span className="links-sub">Wealth AI · trackers + calculators from the book</span>
            </span>
            <span className="links-arrow" aria-hidden="true">→</span>
          </Link>

          <Link to="/" className="links-link">
            <span className="links-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="9" />
                <path d="M3 12h18" />
                <path d="M12 3a13 13 0 0 1 0 18" />
                <path d="M12 3a13 13 0 0 0 0 18" />
              </svg>
            </span>
            <span className="links-text">
              <span className="links-title">Wealth Financial Systems</span>
              <span className="links-sub">Notches options research · weekly report</span>
            </span>
            <span className="links-arrow" aria-hidden="true">→</span>
          </Link>
        </nav>

        <div className="links-socials" aria-label="Social profiles">
          <a
            className="links-social"
            href={IG_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="4" />
              <circle cx="12" cy="12" r="3.6" />
              <circle cx="17.3" cy="6.7" r="0.6" fill="currentColor" stroke="none" />
            </svg>
          </a>
          <a
            className="links-social"
            href={TIKTOK_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="TikTok"
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M16.6 5.7a5 5 0 0 1-3.4-1.7v9.4a4.6 4.6 0 1 1-4.6-4.6c.3 0 .5 0 .8.1v2.4c-.3-.1-.5-.1-.8-.1a2.3 2.3 0 1 0 2.3 2.3V2h2.4a5 5 0 0 0 3.3 3.7z" />
            </svg>
          </a>
          <a
            className="links-social"
            href={LINKEDIN_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M20.45 20.45h-3.55v-5.57c0-1.33-.03-3.04-1.85-3.04-1.85 0-2.13 1.45-2.13 2.94v5.67H9.36V9h3.41v1.56h.05a3.74 3.74 0 0 1 3.36-1.85c3.6 0 4.27 2.37 4.27 5.45zM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12zM7.12 20.45H3.56V9h3.56z" />
            </svg>
          </a>
        </div>

        <footer className="links-footer">
          &copy; Wealth Financial Systems
          <span className="links-foot-domain">wealthfinancialsystems.com/links</span>
        </footer>
      </main>
    </div>
  );
};
